import React from 'react';
import Monitoring from './Monitoring';

const MonitoringLogs = () => {
  return <Monitoring mainView="logs" />;
};

export default MonitoringLogs;
